import React from 'react';
import { Icon, Tooltip } from 'antd';
import moment from 'moment';
import 'moment-timezone';
import formatter from '../../../../../../utils/formatter';
import { todayDate } from "../../../../../../utils/commonUtil";
import { ExchangeFromTable } from "./styles";
import { ColumnTitleMobile, ColumnValue, UnderlyingContent } from "../../styles";
import { AllocationType as AllocationTypeConstants, ExchangeType as ExchangeTypeConstants } from '../../constants';
import { replaceSelect } from "../../../../../../utils/replacer";

const FromTable = (props) => {
    const { dataSource, allocationType: allocationTypeProp, isConfirmation, exchangeType } = props;
    let allocationType = allocationTypeProp
    if(exchangeType === ExchangeTypeConstants.reallocation) {
        allocationType = AllocationTypeConstants.percentage
    }

    const selectedAllocationType =
        (allocationType === AllocationTypeConstants.dollar ? 'Dollars'
            : allocationType === AllocationTypeConstants.unit ? 'Units'
                : allocationType === AllocationTypeConstants.percentage ? 'Percentage'
                    : '');
    const columns = [
        {
            title: 'Investment Options',
            className: "investment-pool-title hide-col-title-in-mobile",
            render: (text) => <div>{replaceSelect(text.poolName)}</div>,
            key: 'name',
            width: '25%',
        },
        {
            title: 'Available Balance',
            className: "hide-col-title-in-mobile",
            render: (text) => {
                let colValue = formatter({
                    value: text.availableBalance,
                    fieldSuffix: 'Dollars',
                })
                return <>
                    <ColumnTitleMobile>Available Balance</ColumnTitleMobile>
                    <ColumnValue>{colValue}</ColumnValue>
                </>
            },
            key: 'availableBalance',
            width: '25%',
        },
        {
            title: () => <>
                <div>Price per unit</div>
            </>,
            className: "hide-col-title-in-mobile",
            render: (text) => {
                const perUpdatedOn = 'Price updated on ' + moment(moment.tz(text.dateOfPricePerUnit, 'America/New_York')).format('MM/DD/YYYY') 
                return <>
                    <ColumnTitleMobile>Price per unit</ColumnTitleMobile>
                    <ColumnValue>
                        <Tooltip placement="bottomLeft" title={perUpdatedOn}>
                            <UnderlyingContent>
                                {formatter({
                                    value: text.pricePerUnit,
                                    fieldSuffix: 'Dollars',
                                })}
                                <Icon type={text.isRise ? 'caret-up' : 'caret-down'} />
                            </UnderlyingContent>
                        </Tooltip>
                    </ColumnValue>
                </>
            },
            key: 'pricePerUnit',
            width: '25%',
        },
        {
            title: () => selectedAllocationType,
            className: "hide-col-title-in-mobile",
            render: (text, item) => {
                let colValue = formatter({
                    value: text[allocationType],
                    fieldSuffix: selectedAllocationType,
                })
                return <>
                    <ColumnTitleMobile>{selectedAllocationType}</ColumnTitleMobile>
                    <ColumnValue>{colValue}</ColumnValue>
                </>
            },
            key: 'activeExchangeUnit',
            width: '25%',
        },
    ];

    const column = [
        {
            title: 'Investment Options',
            className: "investment-pool-title hide-col-title-in-mobile",
            render: (text) => replaceSelect(text.poolName),
            key: 'name',
            width: '25%',
        },
        {
            title: () => selectedAllocationType,
            className: "hide-col-title-in-mobile cell-w100",
            render: (text, item) => {
                let colValue = formatter({
                    value: text[allocationType],
                    fieldSuffix: selectedAllocationType,
                })
                return <>
                    <ColumnTitleMobile>{selectedAllocationType}</ColumnTitleMobile>
                    <ColumnValue>{colValue}</ColumnValue>
                </>
            },
            key: 'activeExchangeUnit',
            width: '25%',
        }
    ]

    if(props.isPrintCheck){
        return props.printRender(isConfirmation ? column : columns);
    }

    return (
        <ExchangeFromTable
            pagination={false}            
            columns={isConfirmation ? column : columns}
            dataSource={dataSource}
            rowKey={(record) => record.poolId}
        />
    );
};

export default FromTable;